import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-csrs-list',
  templateUrl: './csrs-list.component.html',
  styleUrls: ['./csrs-list.component.css'],
})
export class CsrsListComponent implements OnInit {
  isLoading = false;
  displayedColumns: string[] = [
    'organizationName',
    'inCropYear',
    'dropRegNo',
    'regAddr',
    'spocName',
    'spocMobile',
  ];
  private listApi = environment.url + environment.newcsrprojectList;
  /**
   * Constructs a new instance of the CsrsListComponent.
   * @param makeapi Service for making API calls.
   * @param getdata Service for managing shared data values.
   */
  constructor(
    private makeapi: ApiService, // Used for API requests
    private getdata: ValueService // Manages application values
  ) {}

  /**
   * The OnInit lifecycle hook.
   * Called when the component is initialized.
   * Sets the visibility of the component to true and fetches the list of CSRS projects.
   */
  ngOnInit(): void {
    // Set the visibility of the component to true
    this.getdata.isVisibleSource.next(true);

    // Fetch the list of CSRS projects
    this.CSRProjectList();
  }
  /**
   * Gets the data from the API based on the pagination event.
   * Updates the list of CSRS projects based on the new pagination data.
   * @param event The pagination event from the Material table
   */
  getServerData(event) {
    // Update the page number and page size
    this.pageNumber = event.pageIndex + 1;
    this.pageSize = event.pageSize;

    // Create the request parameters for the API call
    this.list = {
      listSize: this.pageSize,
      pageNumber: this.pageNumber,
      status: 1,
    };

    // Call the API to get the updated data
    this.ListApi();
  }
  list = {};
  disList: any = [];
  pageTotalCount: number;
  pageSize: number = 10;
  pageNumber: number = 1;
  noData = true;
  /**
   * Fetches the list of CSR projects from the API based on the pagination.
   * Subscribes to the API response and updates the component data.
   * @returns An observable containing the response from the API.
   */
  CSRProjectList() {
    // Create the API request parameters
    this.list = {
      pageNumber: this.currentPage,
      listSize: this.currentPageCount,
      status: 1, // 1 for completed projects
    };

    // Call the ListApi function to fetch the list of CSR projects
    this.ListApi();
  }
  dataSource: any = [];
  /**
   * Fetches the list of CSR projects from the API.
   * Subscribes to the API response and updates the component data.
   * @returns An observable containing the response from the API.
   */
  ListApi() {
    // Initialize the dataSource to an empty array
    this.dataSource = [];

    // Call the API to fetch the list of CSR projects
    return this.makeapi
      .method(this.listApi, this.list, 'post')
      .subscribe((data) => {
        // Check if the response contains any data
        if (data.count != 0) {
          // If data is present, hide the "No Data" message
          this.noData = false;
          // Set the total number of items
          this.numberOfList = data.listSize;
          // Set the total number of pages
          this.totalPages = data.totalPages;
          // Set the count of items in the response
          this.countList = data.responsemodelList.length;

          // Calculate the start and end count for the current page
          if (
            this.currentPage == this.totalPages &&
            this.countList != this.numberOfList
          ) {
            this.startCount = this.startCount + this.currentPageCount;
            this.EndCount = this.numberOfList;
          } else if (this.countList == this.numberOfList) {
            this.startCount = 1;
            this.EndCount = this.numberOfList;
          }

          // Update the dataSource with the response data
          this.dataSource = data.responsemodelList;
        } else {
          // If no data, show the "No Data" message and clear the dataSource
          this.noData = true;
          this.dataSource = [];
        }
      });
  }
  /**
   * Navigates to the CSR project details page with the given project id as a query parameter.
   * @param id The ID of the CSR project to navigate to.
   */
  viewCSRProject(id: string): void {
    // Encode the ID using base64 encoding
    const encodedId = btoa(id);
    // Navigate to the CSR project details page with the encoded ID as a query parameter
    this.getdata.csrprojectId(encodedId);
  }
  /**
   * Calculates the total number of pages based on the count of data.
   * This function is called whenever the data count changes.
   */
  Pagination_Count() {
    this.loading = false;
    // Get the total count of data
    let totalcount = this.numberOfList;
    // Set the total part count to the total count
    this.totalPartCount = totalcount;
    // Calculate the total number of pages by dividing the total count by the current page count
    // and rounding up to the nearest whole number.
    this.totalPages = Math.ceil(this.totalPartCount / this.currentPageCount);
  }
  p1 = 1;
  totalPartCount: any;
  paginationCount = 1;
  currentPageCount = 9;
  loading = false;
  numberOfList = 0;
  currentPage = 1;
  totalPages = 9;
  show_page = false;
  pagecount = 1;
  startCount = 1;
  EndCount = 9;
  countList = 0;
  /**
   * Handles pagination of the list.
   * @param page - The page to navigate to. Can be 'prev' or 'next'.
   */
  paginatePartList(page: string) {
    // Show the pagination controls
    this.show_page = true;

    // If the user is navigating to the previous page and is not on the first page
    if (page == 'prev' && this.currentPage > 1) {
      // Decrement the page count
      this.pagecount = this.pagecount - 1;

      // If the user is not on the first page
      if (this.currentPage > 1) {
        // Decrement the current page number
        let prevcount = this.currentPage;
        prevcount--;
        // Update the pagination count
        this.paginationCount = prevcount;
        // Update the current page number
        this.currentPage = prevcount;
      } else {
        // If the user is on the first page, set the pagination count to 1
        this.paginationCount = 1;
      }

      // Adjust the start and end counts for the new page
      if (this.EndCount != this.numberOfList) {
        // Decrement the start count
        this.startCount = this.startCount - this.currentPageCount;
        // Decrement the end count
        this.EndCount = this.EndCount - this.currentPageCount;
      } else {
        // If we are at the last page, adjust the start and end counts to the last page
        this.startCount = this.startCount - this.currentPageCount;
        this.EndCount = this.EndCount - this.countList;
      }
    } else {
      // If the user is navigating to the next page
      // Increment the page count
      this.currentPage = this.currentPage + 1;
      this.pagecount = this.pagecount + 1;

      // If the user is not on the last page
      if (this.currentPage > 1) {
        // Increment the current page number
        let nextcount = this.currentPage - 1;
        nextcount++;
        // Update the pagination count
        this.paginationCount = nextcount;
      }

      // Adjust the start and end counts for the new page
      if (this.currentPage != this.totalPages) {
        // Increment the start count
        this.startCount = this.startCount + this.currentPageCount;
        // Increment the end count
        this.EndCount = this.EndCount + this.currentPageCount;
      }
    }

    // Call the event list function to update the list
    this.CSRProjectList();
  }
}
